<template>
<div>
    <div id="IpBanner">   
        <div  class="fcadescript mt-5 mb-5">
        <div class="container content-space-2 content-space-lg-3">
            <div class="row">
            <div class="col-lg-12 mb-9 mb-lg-0">
                <h1 class="sol-001">FCA<span class="sol-002"> 회계 결산 자동화 솔루션</span></h1>
                <div class="sol-003">
                <span class="sol-004" style="display: block;"> Services Providing Efficiency & Accuracy</span>
                <img src="@/assets/journal-bookmark-fill.svg" class="bnsvg" alt="...">
                <img src="@/assets/chart-flow.svg" class="bnsvg" alt="...">
                <img src="@/assets/chart-pie.svg" class="bnsvg" alt="...">
                <img src="@/assets/card-checklist.svg" class="bnsvg" alt="...">
                <img src="@/assets/law-document.svg" class="bnsvg" alt="...">
                <img src="@/assets/dashboard-web.svg" class="bnsvg" alt="...">
                </div>
            </div>
            
            </div>
        </div>
    </div>      

    </div>
    <div >
    <div class="fcadescript2">
        <div  class="container content-space-2 content-space-lg-3">
            <div class="row">
           <div class="card" style="width: 18rem;">
            
            <div class="card-body">
                <img src="@/assets/journal-bookmark-fill.svg" class="card-img-top" alt="...">
                <h5 class="card-title">업무기록 관리</h5>
                <p class="card-text">보다 강화된 업무기록 및 보고 프로세스를 통해 업무 관리의 효율성을 높여 귀하의 팀이 부가가치 작업에 집중할 수 있도록 합니다.</p>
                <a href="#" class="cbtn btn btn-primary">Go somewhere</a>
            </div>
            </div>
            <div class="card" style="width: 18rem;">
            
            <div class="card-body">
                <img src="@/assets/chart-flow.svg" class="card-img-top" alt="...">
                <h5 class="card-title">결산 프로세스 최소화</h5>
                <p class="card-text">결산 프로세스를 최대한 자동화하여 월/분기/반기 마감 관련 수작업을 최소화합니다.</p>
                <a href="#" class="cbtn btn btn-primary">Go somewhere</a>
            </div>
            </div>
            <div class="card" style="width: 18rem;">
            
            <div class="card-body">
                <img src="@/assets/chart-pie.svg" class="card-img-top" alt="...">
                <h5 class="card-title">재무제표 조정 효율화</h5>
                <p class="card-text">재무제표 계정을 최대한 자동으로 Mapping함과 동시에 계정별 검증에 대한 정확성을 확보하여 결산에 투입되는 시간을 효율화합니다.</p>
                <a href="#" class="cbtn btn btn-primary">Go somewhere</a>
            </div>
            </div>
              <div class="card" style="width: 18rem;">
            
            <div class="card-body">
                <img src="@/assets/card-checklist.svg" class="card-img-top" alt="...">
                <h5 class="card-title">결산마감 체크</h5>
                <p class="card-text">결산 마감 작업을 자동으로 실행하여 추가적으로 발생하는 수동적 업무를 최소화 합니다.</p>
                <a href="#" class="cbtn btn btn-primary">Go somewhere</a>
            </div>
            </div>

             <div class="card" style="width: 18rem;">
            
            <div class="card-body">
                <img src="@/assets/law-document.svg" class="card-img-top" alt="...">
                <h5 class="card-title">회계감사 대응</h5>
                <p class="card-text">현직 회계사의 업무 보조를 통해 회계감사에 대응하여 결산을 보다 수월하게 마무리 할 수 있도록 합니다.</p>
                <a href="#" class="cbtn btn btn-primary">Go somewhere</a>
            </div>
            </div>
            <div class="card" style="width: 18rem;">
            
            <div class="card-body">
                <img src="@/assets/dashboard-web.svg" class="card-img-top" alt="...">
                <h5 class="card-title">회계결산 자동화</h5>
                <p class="card-text">자동화된 회계처리 솔루션을 통하여 회계기준을 준수하는 가운데 즉각적으로 수정사항에 대응할 수 있는 통합 솔루션을 제공합니다.</p>
                <a href="#" class="cbtn btn btn-primary">Go somewhere</a>
            </div>
            </div>

            
            </div>
        </div>
    </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'MiddleDesc',
}
</script>

<style scoped>


.fcadescript{height:400px;
background: linear-gradient(to top, rgb(0, 0, 0), rgba(255, 255, 255, 0));

}

.card {
--bs-card-spacer-y: 3rem;    
margin:20px auto;
width:28rem !important;
border: none;
--bs-card-bg:none;}

.card-title {
    margin-top:35px;
    margin-bottom: 35px;
    font-weight:600;
}
.card-img-top {width:40px;}
.bnsvg {background:white; width:60px; border-radius:5px; margin-right: 19px; padding:5px;}
.cbtn { display:none;}

.fcadescript2{
    padding-top:100px !important; padding-bottom:100px !important; }

#IpBanner {
  background-image: url(@/assets/t01.jpeg);
  background-repeat: no-repeat; /* 배경이미지X */
  background-size: cover; /* 요소를 비율에 맞게 커버 */
  background-position: center; /* 이미지를 요소의 정가운데로 처리 */
  background-attachment: fixed; /* 스크롤바 움직일때 이미지가 따라다님 */
}

#IpBanner2 { position:absolute;
width:1150px;
right:0px;  
z-index:-1;
opacity:0.1;
}

.sol-001{padding:50px 50px 15px 50px;
color:white;
font-size:80px;
font-weight:700;  
}

.sol-002{color:white;
padding-left:20px;

font-size:25px;}
.sol-003{padding-left:50px; padding-top:30px; padding-right:50px;
}
.sol-004{ color:white; padding:10px 0px; 
}

</style>